import { useSelector } from 'react-redux';
import { stateGlobal } from '../../interfaces/Global';

const CelularMockup = ({ children }: { children: React.ReactNode }) => {
    const propsState = useSelector((state: stateGlobal) => state.global);
    return (
        <div style={{
            width: '360px',
            height: '740px',
            border: '8px solid #333',
            borderRadius: '36px',
            padding: '20px 0px',
            boxShadow: '0 0 0 4px #888',
            background: propsState.theme === 'dark' ? '#141414' : '#fff',
            position: 'relative',
            overflow: 'hidden',
        }}>
            <div style={{
                position: 'absolute',
                top: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '20px',
                height: '20px',
                background: '#000',
                borderRadius: '50px',
            }} />
            <div style={{
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100px',
                height: '5px',
                background: '#999',
                borderRadius: '3px',
            }} />
            <div style={{ height: '100%', overflowY: 'auto' }}>
                {children}
            </div>
        </div>
    );
};


export default CelularMockup;
